import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { PortfolioMonitoring } from "../../src/landingPage/views/Usecases/PortfolioTracking/PortfolioMonitoring";

const PortfolioMonitoringPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/portfolio-monitoring"
        title={meta.usecases.portfoliomonitoring.title}
        description={meta.usecases.portfoliomonitoring.description}
      />
      <PortfolioMonitoring />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default PortfolioMonitoringPage;
